import { AlertTriangle } from 'lucide-react';

const LEVEL_INFO = {
  FULL: {
    title: 'إعادة تهيئة كاملة',
    items: [
      'مسح جميع البيانات المحلية المخزنة',
      'مسح Cache التطبيق بالكامل',
      'تسجيل خروج جميع المستخدمين',
      'إلغاء أي مزامنة معلقة',
      'إعادة مزامنة كاملة من الخادم الجديد',
    ],
    warning: 'سيحتاج كل مستخدم إعادة تسجيل دخول وانتظار المزامنة الأولية',
    color: 'from-red-900 to-red-800',
  },
  SOFT: {
    title: 'إعادة تهيئة متوسطة',
    items: [
      'مسح البيانات المحلية',
      'تسجيل خروج المستخدم الحالي',
      'إعادة المزامنة بعد تسجيل الدخول',
    ],
    warning: 'ستحتاج إلى إعادة تسجيل الدخول',
    color: 'from-amber-900 to-amber-800',
  },
  CACHE: {
    title: 'مسح الذاكرة المؤقتة',
    items: [
      'مسح البيانات المخزنة مؤقتًا فقط',
      'إعادة تحميل البيانات من الخادم',
      'بدون الحاجة لتسجيل دخول جديد',
    ],
    warning: 'العملية سريعة نسبيًا (~30 ثانية)',
    color: 'from-blue-900 to-blue-800',
  },
};

export default function ResetConfirmDialog({ level, onConfirm, onCancel, isLoading, pendingCount = null }) {
  const info = LEVEL_INFO[level] || LEVEL_INFO.FULL;

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" dir="rtl">
      <div className={`bg-gradient-to-br ${info.color} rounded-2xl p-6 max-w-sm w-full text-white`}>
        <div className="flex items-center gap-2 mb-4">
          <AlertTriangle className="w-5 h-5" />
          <h2 className="text-lg font-black">⚠️ تحذير: {info.title}</h2>
        </div>

        <p className="text-white/80 text-sm mb-4">
          حفظ هذه الإعدادات الجديدة سيؤدي إلى:
        </p>

        <div className="space-y-2 mb-6">
          {info.items.map((item, i) => (
            <div key={i} className="flex items-start gap-2">
              <span className="text-white/60 mt-0.5">•</span>
              <span className="text-sm text-white/70">{item}</span>
            </div>
          ))}
        </div>

        {pendingCount && pendingCount > 0 && (
          <div className="bg-red-500/20 border border-red-500/30 rounded-xl px-3 py-2 mb-4">
            <p className="text-xs text-red-300">
              <span className="font-bold">⚠️ تحذير: </span>
              لديك {pendingCount} عنصر معلق لم يتم مزامنته بعد. المتابعة سيؤدي إلى فقدانها.
            </p>
          </div>
        )}

        <div className="bg-white/10 rounded-xl px-3 py-2 mb-6">
          <p className="text-xs text-white/70">
            <span className="font-bold">⚠️ ملاحظة: </span>
            {info.warning}
          </p>
        </div>

        <p className="text-sm text-white/50 mb-6 text-center">
          هل أنت متأكد من المتابعة؟
        </p>

        <div className="flex gap-2">
          <button
            onClick={onCancel}
            disabled={isLoading}
            className="flex-1 px-4 py-3 rounded-xl bg-white/10 hover:bg-white/20 disabled:opacity-50 text-white font-bold text-sm transition-colors"
          >
            إلغاء
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1 px-4 py-3 rounded-xl bg-white text-slate-900 hover:bg-white/90 disabled:opacity-50 font-bold text-sm transition-colors"
          >
            {isLoading ? 'جاري...' : 'نعم، احفظ وأعد التهيئة'}
          </button>
        </div>
      </div>
    </div>
  );
}